import React from 'react';
import ErrorPage from './ErrorPage';

const CHUNK_RELOAD_KEY = 'kanplan-chunk-reload-ts';

function isChunkLoadError(error) {
  const msg = String(error?.message || '');
  return msg.includes('ChunkLoadError') || msg.includes('Loading chunk');
}

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[KanPlan Error Boundary]', error, info);

    // Auto-reload once on stale-chunk errors (happens after deploy when
    // the browser still references old chunk filenames).
    if (isChunkLoadError(error)) {
      try {
        const now = Date.now();
        const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || '0');
        const recentlyReloaded = Number.isFinite(last) && last > 0 && now - last < 15_000;
        if (!recentlyReloaded) {
          sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now));
          window.location.reload();
          return; // reload triggered – skip rendering fallback
        }
      } catch {
        // sessionStorage blocked – fall through to manual button
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage
          error={this.state.error}
          errorMessage={this.state.error?.message}
          supportUrl="mailto:support@kanplan.se"
          compact={this.props.compact}
        />
      );
    }
    return this.props.children;
  }
}
